import { Component, Inject, OnInit } from "@angular/core";
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, ValidationErrors } from "@angular/forms";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { AppConfig } from "src/app/configs/app.config";
import { CommonService } from "src/app/core/services/common.service";
import { UserService } from "src/app/core/services/user.service";
import { PaymentDetails } from "src/app/models/user";
import { TermsConditionsComponent } from "../terms-conditions/terms-conditions.component";
@Component({
  selector: "app-add-funds",
  templateUrl: "./add-funds.component.html",
  styleUrls: ["./add-funds.component.scss"],
})
export class AddFundsComponent implements OnInit {
  paymentDetails = new PaymentDetails();
  panelOpenState = false;
  totalPayableAmount;
  payableAmountAvailable: boolean = false;
  isValid: boolean;
  isAgreed: boolean;
  params = {};
  amountControl: UntypedFormGroup;
  currencyOptions: Array<any> = [
    { value: "USD", name: "USD" }
  ];
  readonly imgPath: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public addFundsService: UserService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<any>,
    private formBuilder: UntypedFormBuilder,
    private commonService: CommonService,
  ) {
    this.imgPath = AppConfig.POPUP_LOGO;
  }

  ngOnInit(): void {
    if (this.data.advertiser_id)
      this.params["advertiser_id"] = this.data.advertiser_id;
    else this.params["agency_id"] = this.data.agency_id;
    this.amountControl = this.formBuilder.group({
      entries: ["", [this.validateAmount()]],
    });
    if (this.data.currency != 'USD') this.currencyOptions.unshift({value : this.data.currency, name : this.data.currency})
    this.paymentDetails.transaction_currency = this.data.currency
  }

  openTnc() {
    let dialogRef = this.dialog.open(TermsConditionsComponent, {
      width: "55%",
      height: "70%",
      disableClose: true,
    });
  }

  closeModel() {
    this.dialogRef.close();
  }

  validateAmount(){
    return (control: AbstractControl): ValidationErrors | null => {
      let inValidData = {};
      let amount = control.value
      if ( amount < 1){
        inValidData['minError'] = true
      }
      if ( amount > 10000){
        inValidData['maxError'] = true
      }
      return inValidData
    }
  }

  validate() {
    this.isValid = true;
    if (!this.paymentDetails.amount || this.paymentDetails.amount < 0) {
      this.isValid = false;
    }
    if (!this.paymentDetails.description) {
      this.isValid = false;
    }
    if (!this.isAgreed) {
      this.isValid = false;
    }
    if (this.amountControl.controls.entries.errors != null) {
      this.isValid = false;
    }
  }

  public getTotalAmount() {
    this.addFundsService.totalPayableAmount(this.paymentDetails, this.params).subscribe(
      (res) => {
        this.totalPayableAmount = res
        this.payableAmountAvailable = true
      });
  }

  public createPgsession() {
    this.addFundsService.createPgSession(this.paymentDetails, this.params).subscribe(
      (res) => {
        this.commonService.goToExternalDomain(res.data.url);
      });
  }
}
